"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        content: {
            padding: '48px 0px 40px',
            minWidth: 620,
            position: 'relative',
        },
        innerContent: {
            position: 'relative',
            padding: '0 40px',
        },
        loadingMask: {
            position: 'absolute',
            backgroundColor: 'white',
            opacity: 0.5,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1000,
        },
        bottomMask: {
            width: '100%',
            marginTop: 'auto',
            backgroundColor: theme_1.default.colors.globalBackgroundLight,
        },
        bottomMaskHeight: {
            minHeight: 20,
        },
        alert: {
            marginBottom: 36,
        },
    });
});
